export default __webpack_public_path__ + "static/media/logo.cfe924c8.png";